export interface IMasterDataPurchaser {
  purchaserId: number;
  purchaserKey: string;
  purchaserName: string;
  isActive: boolean;
  metadata: string | null;
  searchKeywords: string | null;
  defaultProductCategoryId: number | null;
  defaultProductCategoryName: string | null;
  intelligenceFilter: string | null;
  discountPercentageCredit: number | null;
  deductionTypeInvoicePatternForDiscount: string | null;
  discountPercentageDeduction: number | null;
  discountTermAgreementDays: number | null;
  additionalFieldMapping: string | null;
  discountTermAgreementDaysTolerance: number | null;
  distributionCentersCount: number;
}

export class MasterDataPurchaser {
  private readonly _purchaserId: number;
  private readonly _purchaserKey: string;
  private readonly _purchaserName: string;
  private readonly _isActive: boolean;
  private readonly _metadata: string | null;
  private readonly _searchKeywords: string | null;
  private readonly _defaultProductCategoryId: number | null;
  private readonly _defaultProductCategoryName: string | null;
  private readonly _intelligenceFilter: string | null;
  private readonly _discountPercentageCredit: number | null;
  private readonly _deductionTypeInvoicePatternForDiscount: string | null;
  private readonly _discountPercentageDeduction: number | null;
  private readonly _discountTermAgreementDays: number | null;
  private readonly _additionalFieldMapping: string | null;
  private readonly _discountTermAgreementDaysTolerance: number | null;
  private readonly _distributionCentersCount: number;

  constructor(props: IMasterDataPurchaser) {
    this._purchaserId = props.purchaserId;
    this._purchaserKey = props.purchaserKey;
    this._purchaserName = props.purchaserName;
    this._isActive = props.isActive;
    this._metadata = props.metadata;
    this._searchKeywords = props.searchKeywords;
    this._defaultProductCategoryId = props.defaultProductCategoryId;
    this._defaultProductCategoryName = props.defaultProductCategoryName;
    this._intelligenceFilter = props.intelligenceFilter;
    this._discountPercentageCredit = props.discountPercentageCredit;
    this._deductionTypeInvoicePatternForDiscount =
      props.deductionTypeInvoicePatternForDiscount;
    this._discountPercentageDeduction = props.discountPercentageDeduction;
    this._discountTermAgreementDays = props.discountTermAgreementDays;
    this._additionalFieldMapping = props.additionalFieldMapping;
    this._discountTermAgreementDaysTolerance =
      props.discountTermAgreementDaysTolerance;
    this._distributionCentersCount = props.distributionCentersCount;
  }

  get purchaserId(): number {
    return this._purchaserId;
  }
  get purchaserKey(): string {
    return this._purchaserKey;
  }
  get purchaserName(): string {
    return this._purchaserName;
  }
  get isActive(): boolean {
    return this._isActive;
  }
  get metadata(): string | null {
    return this._metadata;
  }
  get searchKeywords(): string | null {
    return this._searchKeywords;
  }
  get defaultProductCategoryId(): number | null {
    return this._defaultProductCategoryId;
  }
  get defaultProductCategoryName(): string | null {
    return this._defaultProductCategoryName;
  }
  get intelligenceFilter(): string | null {
    return this._intelligenceFilter;
  }
  get discountPercentageCredit(): number | null {
    return this._discountPercentageCredit;
  }
  get deductionTypeInvoicePatternForDiscount(): string | null {
    return this._deductionTypeInvoicePatternForDiscount;
  }
  get discountPercentageDeduction(): number | null {
    return this._discountPercentageDeduction;
  }
  get discountTermAgreementDays(): number | null {
    return this._discountTermAgreementDays;
  }
  get additionalFieldMapping(): string | null {
    return this._additionalFieldMapping;
  }
  get discountTermAgreementDaysTolerance(): number | null {
    return this._discountTermAgreementDaysTolerance;
  }
  get distributionCentersCount(): number {
    return this._distributionCentersCount;
  }

  static from(props: IMasterDataPurchaser): MasterDataPurchaser {
    return new MasterDataPurchaser(props);
  }

  static toJSON(entity: MasterDataPurchaser): IMasterDataPurchaser {
    return {
      purchaserId: entity.purchaserId,
      purchaserKey: entity.purchaserKey,
      purchaserName: entity.purchaserName,
      isActive: entity.isActive,
      metadata: entity.metadata,
      searchKeywords: entity.searchKeywords,
      defaultProductCategoryId: entity.defaultProductCategoryId,
      defaultProductCategoryName: entity.defaultProductCategoryName,
      intelligenceFilter: entity.intelligenceFilter,
      discountPercentageCredit: entity.discountPercentageCredit,
      deductionTypeInvoicePatternForDiscount:
        entity.deductionTypeInvoicePatternForDiscount,
      discountPercentageDeduction: entity.discountPercentageDeduction,
      discountTermAgreementDays: entity.discountTermAgreementDays,
      additionalFieldMapping: entity.additionalFieldMapping,
      discountTermAgreementDaysTolerance:
        entity.discountTermAgreementDaysTolerance,
      distributionCentersCount: entity.distributionCentersCount,
    };
  }
}
